import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

export default {
  [IntegrationTypes.CLEAR_SALE]: 'clearsale',
};
